import { Document, Font, Page, Text, View } from "@react-pdf/renderer";
import { HeaderPdf } from "./headerPdf";
import { styles } from "./styles";
import { Footer } from "./footerPdf";
import { FirstPage } from "./firstPage";
import { Teoric } from "./teoricPage";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { SlaPage } from "./slaPage";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { OnuSla } from "./onu/onuSla";
import { OnuSlaFirstPage } from "./onu/onuFirstPage";
import { RfoFirstPage } from "./rfo/rfoFirstPage";
import { CtaReport } from "./cta/cta";
import { TempHeaderPdf } from "./tempHeaderPdf";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("pt-br");

const TIMEZONE = "America/Sao_Paulo";

Font.register({
	family: "Noto Sans",
	src: "http://fonts.gstatic.com/s/notosans/v6/LeFlHvsZjXu2c3ZRgBq9nKCWcynf_cDxXwCLxiixG1c.ttf",
});

export const PageTemplateEasyReport = ({
	relatorio,
	graphcs,
	enterpriseConfig,
	selectPages = {
		availability: false,
		rfo: false,
		onu: false,
		teoric: true,
		sla: true,
		selectSla: {
			availability: true,
			latency: true,
			packetLoss: true,
			table: true,
		},
	},
	onuSla,
	rfos,
	totalTickets = 0,
}) => {
	const sharedOptions = {
		dataInicial: dayjs(relatorio?.dataInicial)
			.tz(TIMEZONE)
			.format("DD/MM/YYYY"),
		horaInicial: dayjs(relatorio?.dataInicial).tz(TIMEZONE).format("HH:mm:ss"),
		dataFinal: dayjs(relatorio?.dataFinal).tz(TIMEZONE).format("DD/MM/YYYY"),
		horaFinal: dayjs(relatorio?.dataFinal).tz(TIMEZONE).format("HH:mm:ss"),
		countGraphcs: 1,
		countPage: 1,
	};

	const PdfPageWrapper = ({
		children,
		hideRange = false,
		upsertReport = {},
		key = null,
	}) => {
		return (
			<Page
				size="A4"
				style={styles.body}
				pageTitle="relatorio"
				key={key || relatorio?.id}
			>
				<TempHeaderPdf
					relatorio={{ ...relatorio, ...upsertReport }}
					enterpriseConfig={enterpriseConfig}
					sharedOptions={!hideRange ? sharedOptions : null}
				/>
				{children}
				<Footer
					createdAt={`${dayjs(relatorio?.createdAt).format(
						"DD/MM/YYYY",
					)} ${dayjs(relatorio?.createdAt).tz(TIMEZONE).format("HH:mm:ss")}`}
				/>
			</Page>
		);
	};

	return (
		<Document>
			{!!selectPages?.availability && (
				<Page
					size="A4"
					style={styles.body}
					pageTitle="relatorio"
					key={relatorio?.id}
				>
					<TempHeaderPdf
						relatorio={{ ...relatorio }}
						enterpriseConfig={enterpriseConfig}
						sharedOptions={!false ? sharedOptions : null}
					/>
					<CtaReport
						sharedOptions={sharedOptions}
						relatorio={relatorio}
						rfos={rfos}
						graphcs={graphcs}
						totalTickets={totalTickets}
					/>
					<Footer
						createdAt={`${dayjs(relatorio?.createdAt).format(
							"DD/MM/YYYY",
						)} ${dayjs(relatorio?.createdAt).tz(TIMEZONE).format("HH:mm:ss")}`}
					/>
				</Page>
			)}
			{selectPages?.onu && (
				<PdfPageWrapper>
					<OnuSlaFirstPage
						relatorio={relatorio}
						sharedOptions={sharedOptions}
					/>
				</PdfPageWrapper>
			)}

			{selectPages?.rfo && (
				<PdfPageWrapper>
					<RfoFirstPage
						relatorio={relatorio}
						sharedOptions={sharedOptions}
						rfos={rfos}
						totalTickets={totalTickets}
					/>
				</PdfPageWrapper>
			)}

			{selectPages?.onu &&
				Array.isArray(onuSla?.results) &&
				onuSla?.results?.map((item, index) => (
					<PdfPageWrapper
						key={index}
						upsertReport={{
							titulo: `${item?.servico?.id_cliente_servico} | ${item?.onu?.onuItem}`,
						}}
					>
						<OnuSla
							relatorio={{
								source: relatorio?.source,
								rxPowerMean: item?.rxPowerMean,
								availability: item?.availability,
								rxPowerRef: onuSla?.rxPowerRef,
								availabilityRef: onuSla?.availabilityRef,
								observacoes: relatorio?.observacoes,
							}}
							graphcs={{
								graphOnuRxPower: item?.graphRxPower || "",
								graphOnuAvailability: item?.graphAvailability || "",
							}}
							sharedOptions={sharedOptions}
						/>
					</PdfPageWrapper>
				))}

			{!selectPages?.availability && !selectPages?.onu && !selectPages?.rfo && (
				<PdfPageWrapper>
					<FirstPage
						relatorio={relatorio}
						graphcs={graphcs}
						sharedOptions={sharedOptions}
						show={selectPages?.selectConsume}
					/>
				</PdfPageWrapper>
			)}

			{!selectPages?.availability &&
				!!selectPages?.selectSla &&
				Object.values(selectPages.selectSla).some(Boolean) && (
					<PdfPageWrapper>
						<SlaPage
							relatorio={relatorio}
							graphcs={graphcs}
							sharedOptions={sharedOptions}
							show={selectPages?.selectSla}
						/>
					</PdfPageWrapper>
				)}

			{!selectPages?.onu && !selectPages?.rfo && !!selectPages?.teoric && (
				<PdfPageWrapper hideRange={true}>
					<Teoric
						hideCharts={relatorio?.hideCharts}
						percentil={relatorio?.percentil}
					/>
				</PdfPageWrapper>
			)}
		</Document>
	);
};
